import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/69cdc678c3f84800136c321e_1784267819260_04284b07/noticopa/src/app/standings/page.tsx");
